/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateSubjectStatus.defs.js'
export * as $defs from './updateSubjectStatus.defs.js'
